import Typography from '@ixigo/iui/Typography';
import placeholder from '../../images/filePlaceholder.svg';
import { openExternalLink } from '../../utils/pwa';
import MessageBubble from '../MessageBubble';
import { Message, MessageFile } from './index.types';

type Props = {
    fileData: MessageFile;
    message: Message;
};

function File({ fileData, message }: Props) {
    const { name, type, url } = fileData;
    const { actor, createdAt } = message;

    let src;
    let text;

    if (type === 'image') {
        src = url;
    } else {
        src = placeholder;
        text = name;
    }

    return (
        <MessageBubble actor={actor} timestamp={createdAt}>
            <img
                src={src}
                alt={name}
                className='h-36 rounded-10 cursor-pointer'
                onClick={() => openExternalLink(url)}
            />
            {text && <Typography variant='body-md'>{name}</Typography>}
        </MessageBubble>
    );
}

export default File;
